/**
 * <Nwea /> — "NWEA" 로고 문자열 전용 래퍼.
 *
 * 2026-09-13 · 모든 학생 노출 화면에서 "NWEA" 라는 4글자만 Montserrat 800 으로 표시.
 * `.font-nwea` 유틸리티 (`src/app/globals.css`) 가 `--font-nwea` (Montserrat 800) 를
 * `font-family` 로 지정하고 `font-weight: 800` 를 강제한다.
 *
 * 시험 문항 화면 (`src/app/test/page.tsx` 문항 렌더) 및 관리자 화면
 * (`src/app/admin/**`) 에서는 사용하지 않는다.
 *
 * 사용 예 :
 *   <Nwea /> MAP TEST 모의고사
 *   실제 <Nwea /> MAP TEST 와 동일한 인터페이스
 */
import React from "react";

interface NweaProps {
  className?: string;
}

export default function Nwea({ className }: NweaProps) {
  return <span className={`font-nwea${className ? ` ${className}` : ""}`}>NWEA</span>;
}

/**
 * 문자열 안의 "NWEA" 를 자동으로 <Nwea /> 로 감싸 React 노드 배열 반환.
 * 문자열 상수 (배열 desc 등) 를 직접 렌더할 때 편의용. React.Fragment 안에서
 * 사용 가능한 배열/노드를 반환한다.
 */
export function renderWithNwea(text: string): React.ReactNode {
  const parts = text.split(/(NWEA)/g);
  return parts.map((p, i) => (p === "NWEA" ? <Nwea key={i} /> : <React.Fragment key={i}>{p}</React.Fragment>));
}
